import { render, staticRenderFns } from "./GittiGidiyor.vue?vue&type=template&id=3461c958&scoped=true"
import script from "./GittiGidiyor.vue?vue&type=script&lang=js"
export * from "./GittiGidiyor.vue?vue&type=script&lang=js"
import style0 from "./GittiGidiyor.vue?vue&type=style&index=0&id=3461c958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3461c958",
  null
  
)

export default component.exports